const ACTIVE_CLASS = "expanding-blocks__block--active";

class ExpandingBlocks extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      accordionItem: ".expanding-blocks__block",
      accordionButton: ".expanding-blocks__toggle",
      accordionContent: ".expanding-blocks__content",
    };

    this.accordionItems = [
      ...this.querySelectorAll(this.selectors.accordionItem),
    ];

    this.init(this.accordionItems);

    if (this.group) {
      document.addEventListener("expanding-block:opened", (e) => {
        if (e.target === this) return;

        this.closeAllAccordions();
      });
    }
  }

  init(items) {
    items.forEach((item) => {
      const button = item.querySelector(this.selectors.accordionButton);
      button.addEventListener("click", (event) => {
        const item = event.target.closest(this.selectors.accordionItem);

        if (!item.classList.contains(ACTIVE_CLASS)) {
          this.closeAllAccordions(item);
          this.openAccordion(item);
        }
      });

      if (item.classList.contains(ACTIVE_CLASS)) {
        this.openAccordion(item);
      }
    });
  }

  closeAllAccordions(currentItem) {
    this.accordionItems.forEach((item) => {
      if (currentItem != item) {
        this.closeAccordion(item, false);
      }
    });
  }

  openAccordion(item) {
    if (item.classList.contains(ACTIVE_CLASS)) return;
    this.dispatchEvent(
      new CustomEvent("expanding-block:opened", { bubbles: true }),
    );

    const button = item.querySelector(this.selectors.accordionButton);
    button.setAttribute("aria-expanded", true);

    const content = item.querySelector(this.selectors.accordionContent);

    content.style.display = null;

    window.requestAnimationFrame(() => {
      content.style.setProperty(
        "--content-height",
        `${content.scrollHeight}px`,
      );
      item.classList.add(ACTIVE_CLASS);
    });
  }

  closeAccordion(item) {
    if (!item.classList.contains(ACTIVE_CLASS)) return;

    const content = item.querySelector(this.selectors.accordionContent);

    item.removeEventListener("transitionend", this.onEnd);

    this.onEnd = () => {
      item.removeEventListener("transitionend", this.onEnd);
      content.style.display = "none";

      const button = item.querySelector(this.selectors.accordionButton);
      button.setAttribute("aria-expanded", false);
    };

    item.addEventListener("transitionend", this.onEnd);
    content.style.setProperty("--content-height", `${content.scrollHeight}px`);

    window.requestAnimationFrame(() => {
      item.classList.remove(ACTIVE_CLASS);
    });
  }
}

if (!customElements.get("expanding-blocks")) {
  customElements.define("expanding-blocks", ExpandingBlocks);
}
